<template>
  <div class="login-container">
    <div class="w-1200 ">
      <h1>
      注册协议
      </h1>
      <div class="auth-content"><p>
        信阳市免申即享企业服务平台是由信阳市政务服务和大数据管理局（以下简称本单位）建设的系统及附随的信息服务（以下简称本系统）。为明确双方权利义务，平台用户和本单位签订协议如下。
      </p>
        <div class="font-weight-bold">
          一、服务条款确认
        </div>
        <p>
          用户在使用本服务前应当同意本协议的条款并按照页面上的提示完成全部的注册程序。用户在进行注册程序过程中点击“同意”按键即表示用户与本单位达成协议，完全接受本协议项下的全部条款。
        </p>
        <div class="font-weight-bold">
          二、用户主体资格
        </div>
        <p>
          本平台用户应系在中国境内合法注册登记的法人主体或合法成立，取得营业执照，具有一定的组织机构和财产的企业机构及其分支机构，并且合法存续，未被列入失信名单或惩戒名单的单位。用户在注册时应提交清晰的加盖公章的有效期内的营业执照扫描件及本系统要求的其它资料。
        </p>
        <div class="font-weight-bold">
          三、服务条款修改
        </div>
        <p>
          本系统在必要时可修改本服务条款，并在系统上进行更新，一经发布，立即生效。如您继续使用服务，则视为您已接受修订的服务条款。
        </p>
        <div class="font-weight-bold">
          四、用户注册
        </div>
        <p>
          考虑到本系统用户信息的重要性，用户应在注册时提供真实、完整及准确的资料，并在发生变更时及时上传更新信息。盗用其它单位信息注册本系统所引发起的一切不当后果与本系统无关，本系统不承担因此造成的任何法律责任。
        </p>
        <p>
          用户注册成功后，本系统将给予每个用户一个用户帐号及相应的密码，该用户帐号和密码由用户负责保管；用户应当对以其用户帐号进行的所有活动和事件负法律责任。
        </p>
        <p>
          本系统有权对用户提供的资料进行核验，核验结果仅适用于用户在本系统办理注册以及查询本单位相关信息业务；如用户提供的资料不准确，或无法通过本系统核验，或本系统有合理的理由认为该资料不真实、不完整、不准确，或有企业、事业单位、国家行政机关、政府反馈该用户所提供存在虚假、隐瞒、夸大、不实信息影响到本系统相关数据真实可靠性，本系统有权暂停或终止该用户的注册身份及资料，并拒绝该用户继续使用本系统的服务。
        </p>
        <p>
          用户在本系统注册后，必须遵循以下原则：
        </p>
        <p>
          (a)遵守中国有关的法律和法规；
        </p>
        <p>
          (b)不得为任何非法目的而使用网络服务系统；
        </p>
        <p>
          (c)遵守所有与网络服务有关的网络协议、规定和程序；
        </p>
        <p>
          (d)不得利用本系统进行任何可能对互联网的正常运转造成不利影响的行为；
        </p>
        <p>
          (e)不得利用本系统传输任何骚扰性的、中伤他人的、辱骂性的、恐吓性的、庯俗淫秽的或其他任何非法的信息资料；
        </p>
        <p>
          (f)如发现任何非法使用用户帐号或帐号出现安全漏洞的情况，应立即通告本单位。
        </p>
        <div class="font-weight-bold">
          五、用户资料及保密
        </div>
        <p>
          为更为有效地向用户提供政策信息服务，用户同意并授权：本单位有权采集用户注册及使用本服务过程中所提供、形成的信息并提供给本系统对接的相关政府部门或公用事业单位等合作单位，本系统将不会向用户所使用服务所涉及合作单位之外的其他方公开或透露用户资料，但下列情况除外。
        </p>
        <p>
          (a)事先获得用户的明确授权;
        </p>
        <p>
          (b)根据有关的法律法规要求;
        </p>
        <p>
          (c)按照相关政府主管部门的要求;
        </p>
        <p>
          (d)为维护社会公众的利益;
        </p>
        <p>
          (e)为维护本单位的合法权益。
        </p>
        <div class="font-weight-bold">
          六、责任范围及免责声明
        </div>
        <p>
          为本系统提供数据信息的相关政府或公共事业单位等合作单位，所提供之数据信息品质及内容由该合作单位自行负责，本系统不保证该信息之准确、及时和完整。 本单位负责平台的日常维护等工作，仅对本服务条款的服务内容在技术条件允许的情况下作出承诺，不对因其他服务或其它原因导致平台不能正常运行作出任何承诺。
        </p>
        <p>
          下列情形可能影响平台的正常使用，建议用户留意平台管理部门的提示，避免在此类情况下使用平台办理相关事务
        </p>
        <p>
          (a)平台在进行系统配置、维护时，需要定期短时间中断服务；
        </p>
        <p>
          (b)互联网上通路的偶然阻塞，可能造成用户访问的速度下降，甚至短时间不能正常使用本协议规定的服务。对于突发性自然灾害、政府指令、战争等不可抗力原因所导致本单位无法完全或部分履行本协议的，本单位可据此免责。
        </p>
        <div class="font-weight-bold">
          七、内容所有权
        </div>
        <p>
          1、本服务提供的网络服务内容可能包括：文字、软件、声音、图片、录象、图表等。所有这些内容受版权、商标和其它财产所有权、用户信息保护等方面中国法律的保护。
        </p>
        <p>
          2、用户只有在获得本单位或其他相关权利人的授权之后才能使用这些内容，而不能擅自破解、破坏、反向工程、抓取、复制、再造、交易、转让这些内容、或创造与内容有关的派生产品。用户超越使用权限所产生的收益归单位所有，并应对本单位及被侵害方承担侵权赔偿责任。
        </p>
        <div class="font-weight-bold">
          八、保障
        </div>
        <p>
          用户同意保障和维护本系统的利益，并承担用户或其他人使用用户的资料造成本系统或任何第三方的损失或损害的赔偿责任。
        </p>
        <div class="font-weight-bold">
          九、法律适用与争议解决
        </div>
        <p>
          本协议签订及履行均适用于中华人民共和国法律。双方产生争议难以协商解决时，均有权向信阳仲裁委员会提请仲裁裁决。
        </p></div>
    </div>
  </div>
</template>
<script>
  export default {
    name: "zcxy",
    computed: {
    },
    data() {
      return {};
    },
    methods: {},
  };
</script>

<style lang="scss" scoped>
  .login-container{
    background-color: #fafafa;
  }
  .w-1200 {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    background-color: #fff;
    padding:0 30px;
  }
  h1{
    text-align: center;
    margin-top:40px;
    margin-bottom:10px;
    font-size: 1.5rem;
    font-weight: 500;
  }
  p {
    text-indent: 2rem;
    line-height: 2rem;
  }
  .font-weight-bold {
    font-weight: 600;
    font-size: 0.9rem;
    line-height: 3rem;
  }
</style>
